import React from 'react'
import PropTypes from "prop-types"

//Libs
import slugify from 'slugify'

// Gatsby
import { navigate } from 'gatsby'
import Img from "gatsby-image"

export default function MediumArticle({ article: { title, intro, category, date, author, image } }) {
  return (
    <div onClick={() => navigate(`/blog/${slugify(title)}`)} className="grid grid-cols-12 col-span-12 mb-12 bg-white hover:shadow-lg cursor-pointer" style={{ minHeight: 450 }}>
      <div className="col-span-12 lg:col-span-6">
        <p className="bg-gray-900 mt-0 text-white py-2 px-1 text-center tracking-wide text-sm">{category.toUpperCase()}</p>
        <div className="col-span-10 px-5 pb-2">
          <h6 className="my-2 text-2xl font-bold">{title}</h6>
          <p className="text-lg text-gray-700 font-light">{intro}</p>
          <p className="text-sm md:text-base text-main_color"><span className="font-bold">{author.name}</span>, {date}</p>
        </div>
      </div>
      <div className="col-span-12 lg:col-span-6">
        <Img fluid={image.childImageSharp.fluid} className="md:h-full md:w-full" objectFit="cover" />
      </div>
    </div>
  )
}

MediumArticle.propTypes = {
  article: PropTypes.shape({
    title: PropTypes.string,
    intro: PropTypes.string,
    category: PropTypes.string,
    date: PropTypes.string,
    author: PropTypes.shape({
      name: PropTypes.string,
      picture: PropTypes.string
    }),
    image: PropTypes.object
  })
}